Page contactPage
	title = "Kontakt"
	
	// Form models
	string	firstName
	string	lastName
	string	email
	string	phoneNumber
	string	message
	
	ValidationState	validationState = {}
	bool	isLoading = false
	bool	showSuccess = false

	show: string id = ""
		html.setTitle title + app.titleSuffix

		// Reset form
		firstName	= ""
		lastName	= ""
		email	= ""
		phoneNumber	= ""
		message	= ""
		
		validationState.clear
		showSuccess = false

	draw
		div display:flex, flexDirection:column, alignItems:center, padding:{top:60 bottom:60}
			app.box width:1000px
				div width:100%, display:flex, flexDirection:column, gap:40
					// Header
					div display:flex, flexDirection:column, gap:0
						div text:"Sie haben Fragen? Wir sind für Sie da!", fontSize:32, fontWeight:bold, color:#2b3145
						div text:"Schreiben Sie uns oder rufen Sie an. Wir helfen Ihnen gern weiter.", fontSize:16, color:#7a8195

					// Content Columns
					div display:flex, gap:60
						// Left Column: Contact Info
						div display:flex, flexDirection:column, gap:32
							// Email
							div display:flex, flexDirection:column, gap:8
								img "{backend.url}/media/email_icon.svg", width:32, height:32
								div text:"E-Mail", fontSize:18, fontWeight:bold, color:#2b3145
								div text:"service@123womo.de", fontSize:16, color:primaryColor, textDecoration:underline, cursor:pointer

							// Phone
							div display:flex, flexDirection:column, gap:8
								img "{backend.url}/media/phone_icon.svg", width:32, height:32
								div text:"Telefonnummer", fontSize:18, fontWeight:bold, color:#2b3145
								div text:"02206 95131-0", fontSize:16, color:primaryColor, textDecoration:underline, cursor:pointer

						// Right Column: Form
						div flex:1, backgroundColor:#f9fafb, padding:{32}, borderRadius:16, display:flex, flexDirection:column, gap:24
							grid gridTemplateColumns:[1 1] gap:32
								form.text label:"Vorname", model:firstName, required:true, validationState
								form.text label:"Nachname", model:lastName, required:true, validationState
							
								form.email label:"Email-Adresse", model:email, required:true, validationState
								form.text label:"Telefonnummer für Rückfragen", model:phoneNumber, required:true, validationState

							// Message area - using text for now as textarea might not be in form.l yet, checking form.l again...
							// form.l has 'text' with 'rows' property.
							form.text label:"Wie können wir Ihnen helfen?", model:message, width:100%, rows:6, required:true, validationState

							if showSuccess
								div text:"Vielen Dank für Ihre Nachricht! Wir werden uns so schnell wie möglich bei Ihnen melden.", fontSize:16, color:#2b3145, textAlign:center
							else
								app.button text:"Absenden", isDisabled:isLoading, width:100%
									onClick:
										if validationState.checkForErrorsOrEmptyFields: return
										isLoading = true
										refresh
									
										try
											await backend.post "/api/contact", {firstName, lastName, email, phoneNumber, text:message}
											print "Contact message sent"
											firstName = ""
											lastName = ""
											email = ""
											phoneNumber = ""
											message = ""
											showSuccess = true
											validationState.clear
										catch as error
											print "Contact send error:", error
									
										isLoading = false
										refresh

